import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g transform="translate(5)">
      <path
        d="M16,28 L14,28 L14,19.51 L14.6,19.25 C17.6148525,17.933442 19.6711546,15.0768264 19.9627985,11.799998 C20.2544425,8.52316957 18.734954,5.3483017 16,3.52 L16,11 L6,11 L6,3.52 C3.26504599,5.3483017 1.74555748,8.52316957 2.03720146,11.799998 C2.32884543,15.0768264 4.38514748,17.933442 7.4,19.25 L8,19.51 L8,28 L6,28 L6,20.79 C2.21680462,18.8544508 -0.113097939,14.9128639 0.0151650444,10.6652214 C0.143428028,6.41757893 2.70691122,2.62375397 6.6,0.92 L8,0.31 L8,9 L14,9 L14,0.31 L15.4,0.92 C19.2930888,2.62375397 21.856572,6.41757893 21.984835,10.6652214 C22.1130979,14.9128639 19.7831954,18.8544508 16,20.79 L16,28 Z"/>
      <rect width="10" height="2" x="6" y="30" className="euiIcon__fillSecondary"/>
    </g>
  </svg>
)
